import React, { useState, useEffect } from 'react';
import { Modal, Form, Card, Spinner } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import useAuth from '../../../hooks/useAuth';
import { Row } from 'react-bootstrap';
import DashboardBlog from './DashboardBlog';
import { ref, uploadBytes } from 'firebase/storage';
import swal from 'sweetalert';




const DashboardBlogs = () => {
    const [blogs, setBlogs] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [publishing, setPublishing] = useState(false);


    useEffect(() => {
        setIsLoading(true);
        fetch('https://gentle-tor-99938.herokuapp.com/blogs')
            .then(res => res.json())
            .then((data) => setBlogs(data))
            .finally(() => setIsLoading(false));
    }, [])



    const [modalShow, setModalShow] = useState(false);
    const { register, handleSubmit, reset, formState: { errors } } = useForm();



    const [blogUpload, setBlogUpload] = useState(null);
    const { storage } = useAuth();
    const [uploadPreview, setUploadPreview] = useState(null);



    const uploadOnChange = (event) => {
        setBlogUpload(event.target.files[0]);
        setUploadPreview(URL.createObjectURL(event.target.files[0]));
    }


    const onSubmit = data => {
        if (blogUpload == null) {
            swal("Blog Thumbnail", "Please upload a thumbnail for your blog to publish", "error");
            return 0;
        }
        else {
            setPublishing(true);
            const blogRef = ref(storage, `blogs/blogs${blogs.length + 1}`);
            uploadBytes(blogRef, blogUpload)
                .then(() => {
                    data.blogID = blogs.length + 1;
                    data.image = `https://firebasestorage.googleapis.com/v0/b/degrees-steakhouse.appspot.com/o/blogs%2Fblogs${blogs.length + 1}?alt=media&token=83eb4910-f109-4588-835b-dbeb0ff75170`;
                    fetch(`https://gentle-tor-99938.herokuapp.com/add-blog`, {
                        method: 'POST',
                        headers: {
                            'content-type': 'application/json'
                        },
                        body: JSON.stringify(data)
                    })
                        .then(res => res.json())
                        .then(result => {
                            if (result.insertedId) {
                                setModalShow(false);
                                setBlogs([...blogs, data]);
                                swal("Blog Published", "We have successfully published your blog", "success");
                                reset();
                            }
                            else {
                                swal("Something Went Wrong!", "We couldn't publish your blog. Please try again later", "error");
                            }
                        })
                        .finally(() => setPublishing(false));
                });
        }

    }

    const handleDeleteBlog = id => {
        swal({
            title: "Are you sure?",
            text: `Blog will be removed from website`,
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
            .then((willDelete) => {
                if (willDelete) {
                    const url = `https://gentle-tor-99938.herokuapp.com/blogs/${id}`;
                    fetch(url, {
                        method: 'DELETE'
                    })
                        .then(res => res.json())
                        .then(data => {
                            if (data.deletedCount > 0) {
                                const remainingBlogs = blogs.filter(blog => blog._id !== id);
                                setBlogs(remainingBlogs);
                            }
                        })
                    swal("Blog Removed Successfully", {
                        icon: "success",
                    });

                }
            });
    }







    return (
        <div>
            {
                isLoading
                    ?
                    <div className="spinner d-flex align-items-center justify-content-center">
                        <div className="bounce1"></div>
                        <div className="bounce2"></div>
                        <div className="bounce3"></div>
                    </div>
                    :
                    <div className="my-5">
                        <div className="mb-4 bg-dark rounded-3 p-3 d-flex align-items-center justify-content-between">
                            <h2 className="m-0 text-white text-start fw-bold">Manage Blogs</h2>
                            <button onClick={() => setModalShow(true)} className="btn btn-success">Add Blog</button>



                            <Modal
                                show={modalShow}
                                onHide={() => setModalShow(false)}
                                size="md"
                                aria-labelledby="contained-modal-title-vcenter"
                                centered
                            >
                                <Modal.Header closeButton>
                                    <Modal.Title id="contained-modal-title-vcenter">
                                        Publish your blog
                                    </Modal.Title>
                                </Modal.Header>
                                <Form
                                    onSubmit={handleSubmit(onSubmit)}
                                >
                                    <Card>

                                        <Modal.Body>

                                            <div className="d-flex justify-content-center">
                                                <input id="upload-blog" type="file" className="form-control border-0 d-none"
                                                    onChange={uploadOnChange}
                                                />
                                                <label className="btn btn-warning w-100" htmlFor="upload-blog" style={{
                                                    borderRadius: 0
                                                }}>
                                                    Upload Blog Thumbnail <i className="fa fa-upload"></i>
                                                </label>
                                            </div>

                                            {
                                                uploadPreview
                                                &&
                                                <Card.Img className="mt-4" variant="top" src={uploadPreview}
                                                />
                                            }

                                            <Card.Body>

                                                <div className="d-flex flex-column">
                                                    <p className="fw-bold m-0 mb-2">Title</p>
                                                    <div>
                                                        <input
                                                            name="title"
                                                            type="text" className="form-control m-0"
                                                            {...register("title")}
                                                            required
                                                        />
                                                    </div>
                                                </div>

                                                <div className="d-flex flex-column mt-3">
                                                    <p className="fw-bold m-0 mb-2">Content</p>
                                                    <div>
                                                        <textarea
                                                            name="content"
                                                            type="text" className="form-control m-0"
                                                            style={{
                                                                minHeight: 200,
                                                                maxHeight: 200,
                                                                overflow: 'scroll'
                                                            }}
                                                            {...register("content")}
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                            </Card.Body>
                                        </Modal.Body>
                                    </Card>
                                    <Modal.Footer>
                                        {
                                            publishing
                                                ?
                                                <button className="btn btn-success w-100 disabled d-flex align-items-center justify-content-center">
                                                    <span className="m-0">Loading</span>
                                                    <Spinner className="m-0 ms-2" animation="border" size="sm" />
                                                </button>
                                                :

                                                <button type="submit" className="btn btn-success w-100">
                                                    Publish Blog <FontAwesomeIcon icon={faCircleCheck} />
                                                </button>

                                        }
                                    </Modal.Footer>
                                </Form>
                            </Modal>
                        </div>
                        <div className="my-5 pb-5">
                            <Row xs={1} md={2} className="g-4 pb-5">
                                {
                                    blogs.map(blog => <DashboardBlog
                                        blog={blog}
                                        key={blog._id}
                                        handleDeleteBlog={handleDeleteBlog}
                                    />)
                                }
                            </Row>
                        </div>
                    </div>
            }
        </div>
    );
};

export default DashboardBlogs;